import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-8 md:pt-14 pb-12 md:pb-16 px-4 text-center max-w-5xl mx-auto" data-id="element-77" data-mp="2hvm4m8t8rmbp">
      <motion.h1 initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="text-3xl md:text-6xl font-black text-brand-text mb-4 md:mb-6 leading-[1.05] tracking-tight max-w-3xl mx-auto" data-id="element-78" data-mp="23w3709y23tdn">
        Resolvé un año entero de clases de Pilates en solo{' '}
        <span className="italic text-brand-terracottaText" data-id="element-79" data-mp="2mtxgsq70e8x3">5 minutos</span>
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.06,
      ease: [0.23, 1, 0.32, 1]
    }} className="text-sm md:text-lg text-brand-gray max-w-2xl mx-auto mb-5 md:mb-8" data-id="element-80" data-mp="2rt0ka67cc72y">
        Más de 300 ejercicios ilustrados y 100 clases ya armadas. Elegí, imprimí
        y entrá a la sala con todo listo. Sin preparar nada.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.3,
      delay: 0.12,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative w-full max-w-3xl mx-auto mb-6 md:mb-12" data-id="element-81" data-mp="2beq0qut7usr4">
        <img src="https://cdn.magicpatterns.com/uploads/fmDmBzoMrgRZeiK6jjaaKg/ChatGPT_Image_7_sept_2026,_09_35_46-Photoroom.png" alt="Pack Pilates Listo 360: 6 cuadernos anillados, monitor, tablet y celular con los ejercicios y las clases listas para usar." className="w-full h-auto max-h-[32vh] md:max-h-none object-contain" data-id="element-82" data-mp="2kcs7lqzmsfmb" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.18,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-83" data-mp="3330801by4ryt">
        <CTAButton className="mb-4 w-full sm:w-auto" data-id="element-84" data-mp="18smtbozybf0s" />
        <p className="text-xs md:text-sm text-brand-gray font-medium" data-id="element-85" data-mp="38tuqp3q82mzw">
          $19.990 pago único &middot; Descarga inmediata &middot; Acceso de por
          vida
        </p>
      </motion.div>
    </section>;
}